import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 375B6D36-CFC4-4DB4-BFDE-364E129EDFBB
 * name clock-time-twelve-outline
 * version: 5.2.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/clock-time-twelve-outline.svg
 * tags
 * - Date / Time 
 */
export const ClockTimeTwelveOutlineIcon = createSvgIcon(<><path d="M12 20C16.42 20 20 16.42 20 12S16.42 4 12 4 4 7.58 4 12 7.58 20 12 20M12 2C17.5 2 22 6.5 22 12S17.5 22 12 22C6.47 22 2 17.5 2 12C2 6.5 6.5 2 12 2M12.5 13.03H11V7H12.5V13.03Z" /></>, 'ClockTimeTwelveOutlineIcon');
export default ClockTimeTwelveOutlineIcon